import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingsAnalyticsService } from 'src/app/data/repository/analytics-repository/settings-analytics.service';
import { LogoutService } from 'src/app/data/repository/user-repository/logout.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(
    private dialogref: MatDialogRef<any>,
    private settingAnalytics: SettingsAnalyticsService,
    private logoutService: LogoutService
  ) {}

  ngOnInit() {}

  onAcceptAction() {
    this.settingAnalytics.analyticSettingLogoutCompleted();
    this.logoutService.logout(true);
    this.dialogref.close();
  }

  onRejectAction() {
    this.dialogref.close();
  }
}
